<div class="spinner-inner-container" *ngIf="isLoading">
    <app-spinner></app-spinner>
</div>

<div *ngIf="!isLoading">
    <div *ngIf="error">
        <app-errormessage
                [serverErrorMessage]="error.message"
                [errorMessageTranslationKey]="error.localizationKey">
        </app-errormessage>
    </div>
    <div *ngIf="speakers">
        <div class="container event-speakers-container">
            <p *ngIf="speakers.length == 0" [appTranslate]="'NoSpeakersEvent'">No speakers are associated to this
                event.</p>
            <div class="row">
            <div *ngIf="speakers.length > 0" class="col-md-12 speaker">
                <div id="{{ speaker.id }}" class="speaker-avatar v-align-children" *ngFor="let speaker of speakers">
                    <img class="speaker-avatar-img"
                         src="{{ imageHelper.getImage(speaker.image, speaker.imageUrl) }}"
                         alt="{{speaker.name}}" title="{{speaker.name}}"
                         defaultSrc="{{ imageHelper.getImageUrl(defaultImageUrl) }}"/>
                    <div class="speaker-avatar-abstract">
                        <div class="h4 mb12 text-center-xs">
                            {{ speaker.name }}<span *ngIf="speaker.title">, {{ speaker.title }} </span><span
                                *ngIf="speaker.customFields && speaker.customFields.ti8m_companyid && speaker.customFields.ti8m_companyid.Name"
                                class="speaker-company">, {{speaker.customFields.ti8m_companyid.Name}}</span>
                            <a *ngIf="speaker.linkedin" href="{{speaker.linkedin}}" target="_blank"><i class="fa fa-linkedin-square" aria-hidden="true"></i></a>
                            <a *ngIf="speaker.twitter" href="{{speaker.twitter}}" target="_blank"><i class="fa fa-twitter-square" aria-hidden="true"></i></a>
                        </div>
                        <p *ngIf="speaker.about" class="mb0">{{ speaker.about }}</p>
                    </div>
                </div>
            </div>
            </div>
        </div>
    </div>
</div>
